<fgb-fantasy-player-select [gameId]="id"></fgb-fantasy-player-select>
